import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { normalizeError } from "@/store/helpers/errorHelper";

export interface DocumentInfo {
  errors: unknown;
}

@Module({ namespaced: true, name: "DocumentModule" })
export default class ResidentModule extends VuexModule implements DocumentInfo {
  errors = {};

  get getError() {
    const [errorName] = Object.keys(this.errors);
    const error = this.errors[errorName];
    return error;
  }

  @Mutation
  [Mutations.SET_ERROR](errorObj) {
    this.errors = normalizeError(errorObj);
  }

  @Action
  [Actions.GET_DOCUMENTS](presentOnly = false) {
    const url = presentOnly ? "/documents?presentOnly=true" : "/documents";
    return ApiService.get(url)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }

  @Action
  [Actions.UPLOAD_DOCUMENT](data) {
    // FormData encode undefined and null as string value, so we want to set an empty string instead
    Object.keys(data).forEach((key) => {
      if (data[key] === undefined || data[key] === null) {
        data[key] = "";
      }
    });
    const formData = new FormData();
    if (data.file !== "") {
      formData.append("File", data.file, data.file.name);
    }

    return ApiService.post(`/documents/${data.documentId}/upload`, formData)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
      });
  }
}
